import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const termsAccepted =
    localStorage.getItem('shopcopilot_terms_accepted') === 'true';

  if (!termsAccepted) {
    return <Navigate to="/terms" replace />;
  }

  return children;
};

export default ProtectedRoute;
